<template>
  <div id="add-asset">
    <div class="ContentContainer ContentContainer--WithButton">
      <BackButton />
      <h3 class="heading-lined">{{ $t("add_page.add_asset") }}</h3>

      <p>
        {{ $t("add_page.any_asset.1") }}
        <a href="https://coinmarketcap.com" target="_blank"
          >Coinmarketcap.com</a
        >
        {{ $t("add_page.any_asset.2") }}
      </p>

      <input
        type="text"
        class="form-control form-control-lg mt-4"
        :placeholder="$t('add_page.search')"
        v-model="query"
        ref="input"
        @keyup.enter="goToFirstIfAvailable"
      />

      <table class="table table-striped mt-5" v-if="query.length > 0">
        <colgroup>
          <col width="8%" />
          <col width="20%" />
        </colgroup>
        <tbody>
          <tr
            v-for="coin in filteredCoins"
            v-bind:key="coin.id + coin.price"
          >
            <td>
              {{ coin.name }}
              <em>{{ coin.symbol }}</em>
            </td>
            <td class="text-right" @click.prevent="addCoin(coin)">
              <router-link
                :to="`/edit/${coin.id}`"
                class="btn btn-secondary"
              >
                {{ $t("add_page.next") }}

                <i class="fa fa-angle-double-right ml-2"></i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-if="query.length > 0 && filteredCoins.length === 0">
        {{ $t("add_page.no_result") }} {{ query }}.
      </p>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapActions } from "vuex";
import BackButton from "./../BackButton";

export default {
  name: "AddAsset",
  metaInfo: {
    title: "Add Asset",
  },
  components: {
    BackButton,
  },
  data() {
    return {
      query: "",
      filteredCoins: [],
    };
  },
  watch: {
    query(val) {
      this.fetchSearchResults(val);
    },
  },
  methods: {
    goToFirstIfAvailable() {
      if (this.query.length === 0 || this.filteredCoins.length === 0) {
        return;
      }
      this.addCoin(this.filteredCoins[0]);
      this.$router.push(`/edit/${this.filteredCoins[0].id}`);
    },
    fetchSearchResults: debounce(function (query) {
      if (!query) {
        this.filteredCoins = [];
        return;
      }
      this.searchRequest(query.trim())
        .then((filteredCoins) => {
          this.filteredCoins = filteredCoins;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 500),
    ...mapActions({
      searchRequest: "coinmarketcap/getCoinMarketCapDataByQuery",
      addCoin: "coinmarketcap/addCoin",
    }),
  },
  mounted() {
    this.$refs.input.focus();
  },
};
</script>

<style lang="scss" scoped>
td {
  vertical-align: middle;
  font-size: 18px;
}

em {
  font-style: normal;
  opacity: 0.7;
  font-weight: 300;
}

input {
  padding: 20px 25px;
  border-radius: 8px;
  font-size: 22px;
}
</style>